import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { DeceasedTrigger } from '@frontend/deceased/types';
import { WorkflowTrigger } from '@frontend/workflow/types';
import React from 'react';

const ID = 'deceased-trigger-select';

export interface DeceasedTriggerSelectProps extends Omit<SelectInputV2Props<string>, 'options'> {}

export const DeceasedTriggerSelect = (props: DeceasedTriggerSelectProps) => (
    <SelectInputV2
        {...props}
        id={ID + props.id}
        label={props.label || 'Deceased trigger'}
        options={[...DeceasedTrigger.ALL, ...WorkflowTrigger.ALL].map((trigger) => ({
            value: trigger.value,
            label: trigger.value,
            display: trigger.displayName
        }))}
    />
);

export default DeceasedTriggerSelect;
